import { AlertIcon, Typography } from '@eventbrite/marmalade';
import classnames from 'classnames';
import React, { type FC } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../../utils/rebrand';
import defaultStyles from './Header.module.scss';
import rebrandStyles from './Header.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

type HeaderProps = {
    title: string;
    text: string;
    icon: React.ReactNode;
    isAppRebrandActive: boolean;
    onClick: () => void;
    error?: boolean;
    errorText?: string;
    className?: string;
};

const Header: FC<HeaderProps> = ({
    text,
    title,
    icon,
    onClick,
    error,
    errorText,
    isAppRebrandActive,
    className,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    return (
        <div
            className={classnames(styles.header, className)}
            onClick={onClick}
            role="button"
        >
            <div className={styles.svgContainer}>
                {icon}
                <Typography className={styles.headerText}>{title}</Typography>
            </div>
            <Typography variant="body-md-bold" className={styles.selectedText}>
                {text}
            </Typography>
            {error && errorText && (
                <div className={styles.error}>
                    <AlertIcon size="xsmall" />
                    <Typography variant="body-md-bold">{errorText}</Typography>
                </div>
            )}
        </div>
    );
};

export default Header;
